module.exports = __webpack_public_path__ + "ArjunBhandari-58d9aa05.webp";